import { __extends } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkMenuListItem } from './uitk-menu-list-item.esm.js';
import { UitkHeadingTags, defaultMenuListHeadingTag } from './types.esm.js';
import styles from './uitk-menu.css';

var getClassNameList = classNames.bind(styles);
var UitkMenuList = /** @class */ (function (_super) {
    __extends(UitkMenuList, _super);
    function UitkMenuList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMenuList.prototype.render = function () {
        var _a = this.props, children = _a.children, items = _a.items, title = _a.title, allyHeadingLevel = _a.allyHeadingLevel;
        var HeadingLevel = allyHeadingLevel
            ? UitkHeadingTags.get(allyHeadingLevel)
            : UitkHeadingTags.get(defaultMenuListHeadingTag);
        return (React.createElement("div", { role: "menu", className: getClassNameList('uitk-list uitk-type-400') },
            title && React.createElement(HeadingLevel, { className: getClassNameList('uitk-list-title') }, title),
            items &&
                items.map(function (item, index) {
                    var _a, _b;
                    return (React.createElement(UitkMenuListItem, { Link: item.Link, to: item.to, key: index, analytics: item.analytics, href: item.href, typeAnchor: item.typeAnchor, label: item.label, className: getClassNameList(item.className), role: item.attributes && item.attributes.role, tabIndex: item.attributes && item.attributes.tabindex, iconName: (_a = item.icon) === null || _a === void 0 ? void 0 : _a.name, onClick: item.onClick, target: item.target, selected: item.selected, disabled: item.disabled, iconComponent: (_b = item.icon) === null || _b === void 0 ? void 0 : _b.component }));
                }),
            children));
    };
    UitkMenuList.displayName = 'UitkMenuList';
    return UitkMenuList;
}(React.Component));

export { UitkMenuList };
